import { $ } from '@starberry/components';
import Icon from '@chakra-ui/icon';
import Services from 'core/services/store/auth/services';
import * as AuthActions from 'core/services/store/auth/actions';
import { Routes } from '../../routes';
import { getUser } from 'core/services/store/utils';

const AccountHeader = {
  $: 'Header',

  props: {
    zIndex: 999,
    width: '100%',
    p: '10px',
    position: 'sticky',
    top: 0,
    bgColor: 'white',
    alignItems: 'center',
    templateColumns: { base: 'repeat(3, 1fr) ', md: '250px 1fr 1fr' },
    borderBottomColor: 'gray.300',
    borderBottomWidth: '1px',
    borderRadius: 0,
    px: (_, { theme }) => ({ base: theme.space[2], md: theme.space[12] }),
  },

  search: {
    $: 'InputGroup',
    props: {
      display: { base: 'none', lg: 'flex' },
    },
    children: [
      {
        $: 'Input',
        props: {
          borderWidth: '1px',
          borderColor: 'gray.300',
          placeholder: 'Search',
          borderRadius: 3,
          padding: 2,
          width: '100%',
        },
      },
      {
        $: 'InputRightElement',
        props: {
          pointerEvents: 'none',
        },
        children: [
          {
            component: Icon,
            props: {
              fontSize: 18,
              as: () => $('constants.icons.search'),
              color: 'gray.500',
              mt: 2,
              mr: 1,
            },
          },
        ],
      },
    ],
  },

  avatar: {
    $: 'Avatar',
    provide: ['auth'],
    props: {
      size: 'sm',
      bg: '#bdbdbd',
      display: { base: 'none', lg: 'flex' },
      name: () => getUser()?.name || 'Visitor',
      src: () => getUser()?.picture || '',
    },
  },

  leftZone: ({ search }) => {
    return [search];
  },

  centerZone: [
    {
      $: 'Flex',
      props: {
        display: { base: 'flex', lg: 'none' },
        justify: 'center',
        children: $('title', 'My Account'),
        fontWeight: $('theme.fontWeights.bold'),
      },
    },
  ],

  rightZone: ({ avatar }) => {
    return [
      {
        $: 'Stack',
        props: {
          justify: 'flex-end',
          direction: 'row',
          align: 'center',
          spacing: 9,
        },
        children: [
          // {
          //   $: 'Flex',
          //   props: {
          //     align: 'center',
          //     justify: 'center',
          //     display: { base: 'none', md: 'flex' },
          //   },
          //   children: [
          //     {
          //       $: 'Link',
          //       props: {
          //         href: Routes.InboxPage,
          //         _hover: {
          //           color: $('constants.colors.secondary'),
          //         },
          //       },
          //       children: {
          //         $: 'IconButton',
          //         props: {
          //           fontSize: 24,
          //           variant: 'link',
          //           color: 'inherit',
          //           _hover: {
          //             color: $('constants.colors.secondary'),
          //           },
          //           _focus: {
          //             boxShadow: 'none',
          //           },
          //           icon: () => $('constants.icons.notification'),
          //           width: 10,
          //           height: 10,
          //           borderRadius: 'full',
          //         },
          //       },
          //     },
          //     {
          //       $: 'Badge',
          //       props: {
          //         borderRadius: 'full',
          //         fontWeight: 'normal',
          //         bgColor: $('constants.colors.primary'),
          //         color: 'white',
          //         p: 1.5,
          //         py: 0.5,
          //         border: '2px solid',
          //         borderColor: 'white',
          //         position: 'absolute',
          //         ml: 6,
          //         mt: -6,
          //       },
          //       provide: ['action'],
          //       children: (_, context) =>
          //         context?.state?.action?.[0]?.pendingActionData
          //           ? `${context.state.action[0].pendingActionData.length}`
          //           : '?',
          //     },
          //   ],
          // },
          {
            $: 'Flex',
            props: {
              display: { base: 'flex', md: 'none' },
            },
            children: [
              {
                $: 'HeaderMenuItem',
                provide: ['auth'],
                props: (_, context) => ({
                  rightIcon: 'rightIcon',
                  buttonProps: {
                    px: 0,
                    _hover: {
                      bg: 'transparent',
                    },
                    _focus: {
                      bg: 'transparent',
                    },
                    _active: {
                      bg: 'transparent',
                    },
                  },
                  submenu: [
                    {
                      label: 'Profile',
                      buttonProps: {
                        onClick: () => {
                          window.location.href = Routes.ProfilePage;
                        },
                      },
                    },
                    {
                      label: 'Logout',
                      buttonProps: {
                        onClick: () => {
                          const [, dispatch] = context?.state?.auth || [];
                          Services(dispatch, AuthActions).logout();
                          window.location.href = Routes.LoginPage;
                        },
                      },
                    },
                  ],
                }),
              },
            ],
          },
          {
            $: 'HeaderMenu',
          },

          avatar,
        ],
      },
    ];
  },

  children: ({ leftZone, centerZone, rightZone, avatar, placement, companyLogo, sideNav }) => {
    return [
      {
        $: 'Flex',
        children: [
          {
            $: 'MobileSideMenu',
            sideNav,
            placement,
            companyLogo: () => companyLogo,
          },
          ...leftZone,
        ],
      },
      {
        $: 'Flex',
        props: {
          justify: 'center',
        },
        children: [...centerZone],
      },
      {
        $: 'Flex',
        props: {
          justify: 'flex-end',
        },
        children: [...rightZone],
      },
    ];
  },
};

export default AccountHeader;
